<script>
export default {
  methods: {
    onScrollTo(value) {
      const elScrollHeight = this?.$el?.scrollHeight;

      if (value === "top") {
        this.scrollTo();
      }

      if (value === "bottom") {
        setTimeout(() => {
          this.scrollTo(elScrollHeight);
        }, 500);
      }
    },
    scrollTo(height = 0) {
      this?.$el?.scrollTo({
        top: height,
        left: 0,
        behavior: "smooth",
      });
    },
  },
  render() {
    return this.$scopedSlots.default({
      onScrollTo: this.onScrollTo,
    });
  },
};
</script>
